import protoRoot from "../proto-root";

function create({ enabled, duration }) {
  const LullabyPlayerTimerSettings = protoRoot.lookupType(
    `comm.LullabyPlayerTimerSettings`
  );

  return LullabyPlayerTimerSettings.create({
    enabled,
    duration
  });
}

export default {
  create
};

// message LullabyPlayerTimerSettings {
//   bool enabled = 1;
//   int64 duration = 2;
// }
